<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Loading
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading
      v-if="instrument && instrument.name"
      :title="`Edit ${instrument.name} Jig`"
      class="mb-3"
    >
      <template #right-content>
        <header-button-group :button_config="button_config" />
      </template>
    </basic-heading>
    <instrument-card :instrument="instrument" />
    <instrument-jig-form
      :form_data="form_data"
      @updateFormData="updateFormData"
    />
    <b-row class="mb-4">
      <b-col>
        <b-button
          @click="submit"
          :disabled="save_button_disabled"
          class="float-right py-3 px-5"
          variant="success"
        >
          <i class="fal fa-address-book" /> Save
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import InstrumentJigForm from "@/components/lab/instrument/form/InstrumentJigForm";
import InstrumentCard from "@/components/lab/instrument/InstrumentCard";
import { getModel } from "@/shared/fetch-utils";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";

const InstrumentJigRepository = LabRepositoryFactory.get("instrumentJig");

export default {
  name: "InstrumentJigEdit",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    InstrumentCard,
    InstrumentJigForm,
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-arrow-left",
            linkto: `/instrument/${this.instrument.id}`,
            title: "Back to instrument",
          },
        ],
      };
    },
    save_button_disabled() {
      return !(
        this.form_data.jig_name &&
        this.form_data.jig_capacity &&
        this.form_data.jig_x &&
        this.form_data.jig_y &&
        this.form_data.jig_z
      );
    },
  },
  data() {
    return {
      loading: true,
      instrument_id: this.$route.params.instrument_id || null,
      jig_id: this.$route.params.jig_id || null,
      instrument: null,
      jig: null,
      form_data: {
        name: null,
        capacity: 1,
        jig_name: null,
        jig_capacity: 1,
        jig_x: 1,
        jig_y: 1,
        jig_z: 1,
      },
    };
  },
  methods: {
    updateFormData({ value, field }) {
      this.form_data[field] = value;
    },
    async init() {
      this.instrument = await getModel({
        model_type: "instrument",
        id: this.instrument_id,
        message: this.$bvToast,
      });

      this.jig = this.instrument.jigs.find((jig) => jig.id === this.jig_id);
      this.form_data = {
        name: this.instrument.name,
        capacity: this.instrument.capacity,
        jig_name: this.jig.name,
        jig_capacity: this.jig.capacity,
        jig_x: this.jig.x,
        jig_y: this.jig.y,
        jig_z: this.jig.z,
      };
      this.loading = false;
    },
    async submit() {
      const jig = {
        name: this.form_data.jig_name,
        capacity: this.form_data.jig_capacity,
        x: this.form_data.jig_x,
        y: this.form_data.jig_y,
        z: this.form_data.jig_z,
      };
      // const instrument_jig = new InstrumentJigModel({
      //   instrument_id: this.instrument_id,
      //   jig
      // });

      // try {
      //   const { response } = await instrument_jig.save();
      //   this.$bvToast.toast("New Jig was added to Instrument.", {
      //     title: "Instrument Update successful.",
      //     variant: "success"
      //   });
      // } catch ({ response }) {
      //   this.$bvToast.toast(response.data.error, {
      //     title: "Update Failed.",
      //     variant: "danger"
      //   });
      // }
    },
  },
  created() {
    this.loading = true;

    this.init();
  },
};
</script>
